import React, { PureComponent } from "react";
import PropTypes from "prop-types";
//import classNames from "classnames";
import { Grid, Box, /* isWidthUp, */ withWidth, withStyles, GridList, GridListTile } from "@material-ui/core";
import BlogCardHorizontal from "./BlogCardHorizontal";
import { cdnURL } from './../../../shared/functions/api/'
import format from "date-fns/format";
import styled from 'styled-components';
/* import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia'; */
import ArrowButtonLink from './../../../shared/components/ArrowButtonLink';
import SectionLineTitle from './../../../shared/components/SectionLineTitle';
import { Link } from 'react-router-dom';
import DynamicElement from 'shared/components/DynamicElement'
import { history } from "./../../../App";
import Slider from "@material-ui/core/Slider";

//  https://www.npmjs.com/package/material-ui-search-bar
import SearchBar from "material-ui-search-bar";

const SlideText = styled.div`
    font-family: Lato;
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.25;
    letter-spacing: normal;
    color: #b6b8bc;
    margin: 0;
    padding-bottom: 20px;
    padding-left: 40px;
`;

const MainText = styled.div`
  font-family: MinionPro-Disp;
  font-size: 100px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  text-align: center;
  color: #313438;

  @media (max-width: 600px){
    font-size: 55px;
    line-height: 1.4;
  }
`;

const StyledSearchBar = styled(SearchBar)`
    width: 174px;
    height: 30px;
    margin-left: auto;
    background: transparent;
    border-bottom: 1px solid white;
    border-radius: 0;
    margin-top: 20px;
    
    input{
      font-family: Lato;
      font-size: 15px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.2;
      letter-spacing: normal;
      text-align: left;
      color: #b6b8bc;
    }
    button{
      color: #7f8489;
      padding-right: 6px;
    }
    & > div{
      margin-left: 0;
      margin-right: auto;
      width: auto;
    }
    svg{
      height: 17px;
    }

    @media (max-width: 600px){
      margin-left: 0;
      width: ${props => props.postsCount < 7 ? '100%' : '174px'};
    }
`;

const RectangleInner = (props) => <div {...props}>
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
    <g transform="translate(11 19.001)">
      <g transform="rotate(-90 4.993 4.992)">
        <path id="Trazado_3218" d="M0 0l4.993 5.447L9.985 0" className="cls-1" transform="translate(0 20.474)" />
        <path id="Trazado_3217" d="M0 26V0" className="cls-1" transform="translate(4.994)" />
      </g>
    </g>
  </svg>
</div>;

const Rectangle = styled(RectangleInner)`
    width: 158px;
    height: 100%;
    opacity: 1;
    position: absolute;
    top: 0;
    left: ${props => props.side === 'left' ? '0' : 'auto'};
    right: ${props => props.side === 'left' ? 'auto' : '0'};
    transform: rotate(${props => props.side === 'left' ? '180deg' : '0deg'});
    z-index: 1;

    .cls-1{fill:none;stroke:#8d9298}

    svg{
      cursor: pointer;
      width: 48px;
      height: 48px;
      object-fit: contain;
      margin-left: 12px;
      vertical-align: middle;

      position: absolute;
      top: 50%;
      transform: translateY(-50%);

      right: 0;
    }

    @media (max-width: 600px){
      height: auto;
      position: relative;

      svg{
        border: 1px solid white;
        border-radius: 50%;
        top: auto;
        left: auto;
        bottom: auto;
        right: auto;
      }
    }
`;

const MainTextLarge = styled.div`
  height: 135px;
  font-family: MinionPro-Disp;
  font-size: 135px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  text-align: left;
  color: #313438;

  @media (max-width: 600px){
    font-size: 55px;
    line-height: 1;
    text-align: center;
    height: auto;
  }
`;

const MainNewsTitle = styled.h3`
  font-family: Lato;
  font-size: 24px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: 0.24px;
  text-align: left;
  color: #ffffff;
  margin: 0;

  @media (max-width: 600px){
    text-transform: uppercase;
    font-size: 16px;
    line-height: 1.25;
    letter-spacing: 0.16px;
  }
`;

const MainDescription = styled.p`
  margin-top: 55px;
  width: 318px;
  font-family: Lato;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  text-align: left;
  color: #b6b8bc;

  /* multiple line text supported ellipsis at line 6 */
  display: -webkit-box;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;  
  overflow: hidden;


@media (max-width: 600px){
  margin: 0;
  margin-top: 16px;
  font-family: Lato;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  text-align: left;
  color: #b6b8bc;
}
`;

const ArrowDownIcon = styled((props) => <div {...props}>
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
    <g transform="translate(11 19.001)">
      <g transform="rotate(-90 4.993 4.992)">
        <path id="Trazado_3218" d="M0 0l4.993 5.447L9.985 0" className="cls-1" transform="translate(0 20.474)" />
        <path id="Trazado_3217" d="M0 26V0" className="cls-1" transform="translate(4.994)" />
      </g>
    </g>
  </svg>
</div>)`
    .cls-1{fill:none;stroke:#8d9298}
    svg{
      cursor: pointer;
      width: 48px;
      height: 48px;
      object-fit: contain;
      margin-right: 10px;
      vertical-align: middle;
      transform: rotate(90deg);
    }
`;

const SmallGreyText = styled.span`
  height: 20px;
  font-family: Lato;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.23;
  letter-spacing: normal;
  text-align: left;
  color: #8d9298;
`;

const SmallerGreyText = styled.span`
  height: 15px;
  font-family: Lato;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  text-align: left;
  color: #8d9298;
`;


const styles = theme => ({
  wrapper: {
    minHeight: 470,
    marginTop: 20,
    position: 'relative',
  },
  noDecoration: {
    textDecoration: "none !important"
  },
  gridListWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    paddingLeft: 80,
    paddingRight: 80,
    '@media (max-width: 600px)': {
      flexDirection: 'column',
      padding: 0
    }
  },
  gridList: {
    flexWrap: 'nowrap',
    // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
    transform: 'translateZ(0)',
    overflow: "hidden",
  },
  gridListTile: {
    height: 'auto !important',
    marginRight: 20,
    minWidth: 360,
  },
  sliderWrapper: {
    marginLeft: 40,
    width: 286,
    '@media (max-width: 600px)': {
      marginLeft: 0,
    }
  },
});

const HenigSlider = withStyles({
  root: {
    color: '#ccced3',
    height: 2,
    width: '100%'
  },
  thumb: {
    height: 2,
    width: 30,
    backgroundColor: '#24272b',
    /* border: '2px solid currentColor', */
    marginTop: 0,
    marginLeft: 0,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
    borderRadius: 0
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 14px)',
    color: 'black'
  },
  track: {
    height: 2,
  },
  rail: {
    height: 2,
  },
})(Slider);

const SliderLabel = styled.span`
  height: 20px;
  font-family: MinionPro-Disp;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.4;
  letter-spacing: normal;
  text-align: left;
  color: ${props => props.side === 'right' ? '#484f57' : '#ffffff'};
`;

const Counter = styled.div`
  height: 57px;
  font-family: MinionPro-Disp;
  font-size: 57px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.39;
  letter-spacing: normal;
  color: #313438;
  text-align: right;


  @media (max-width: 600px){
    float: right;
  }
`;


class Blog extends PureComponent {
  state = {
    selectedImg: 0,
    searchValue: '',
  }

  componentDidMount() {
    this.selectBlogAndSearch()
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.search && prevProps.location.search !== this.props.location.search) {
      this.selectBlogAndSearch()
    }
  }

  selectBlogAndSearch() {
    const { selectBlog } = this.props;
    const params = new URLSearchParams(this.props.location.search);
    const searchValue = params.get("keywords")

    if (searchValue) {
      this.setState({ searchValue })
      document.location.hash = '#search';
      selectBlog(true);

      setTimeout(() => {
        history.push('/news')
      }, 500);
    } else {
      selectBlog();
    }
  }



  getVerticalBlogposts = (blogPosts = [], isMobile) => {
    const { /* width, */ classes } = this.props;

    const allPosts = blogPosts;
    if (allPosts.length === 0) return;

    const rows = !isMobile ? 2 : 3;
    const gridRows = [];

    let i = 0;
    for (let index in allPosts) {
      if (!gridRows[i]) {
        gridRows[i] = [];
      }
      gridRows[i].push(allPosts[index]);
      if (index % rows === rows - 1) {
        i++;
      }
    }

    return gridRows.map((elements, index) => (
      <GridListTile
        key={index}
        classes={{ root: classes.gridListTile }}
        // create refs with slider
        tabIndex={index}
        ref={(ref) => {
          if (!this.items) {
            this.items = {};
          }
          this.items[index] = ref;
        }}
      >
        <Grid
          container
          direction="column"
          justify="flex-start"
        >
          {elements.map((blogPost, k) => (
            <BlogCardHorizontal
              key={blogPost.id}
              src={cdnURL + blogPost.src}
              title={blogPost.title}
              snippet={blogPost.snippet}
              date={blogPost.date}
              url={blogPost.url}
            />
          ))}
        </Grid>
      </GridListTile>
    ));
  };

  valuetext(value) {
    return `${value}`;
  }

  onChange(value) {
    const { width } = this.props;
    const isMobile = width === 'xs';
    // show the selected item by scrolling to it with a smooth animation, 
    // this also keeps the page scroll unchanged. 
    const index = (value - 1) * (isMobile ? 1 : 3);
    console.log(value, index)
    this.items[index].scrollIntoView({
      behavior: "smooth",
      inline: "start",
      block: 'nearest',
    });

    this.setState({ selectedImg: value - 1 });
  }

  render() {
    const { classes, width } = this.props;
    let { blogPosts = [] } = this.props;
    const { selectedImg, searchValue } = this.state;

    const isMobile = width === 'xs';

    let morePosts = [...blogPosts];
    const firstPost = morePosts.shift();

    // get other posts that have the same tags in this post
    const related = morePosts.filter(a => a.related.some(tag => firstPost.related.includes(tag))).slice(0, 3)


    if (searchValue) {
      morePosts = morePosts.filter(p => {
        return p.title.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1 ||
          p.content.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1 ||
          p.related.find(tag => tag.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1);
      })
    }

    return (
      <div style={{ backgroundColor: "#121416", position: 'relative', paddingLeft: 40, paddingRight: 40, paddingBottom: 40 }}>
        <div className="lg-p-top">

          <DynamicElement to="/admin/posts" style={{ position: 'absolute', top: 80, right: 20 }}>
            Manage News
          </DynamicElement>

          <div>
            {blogPosts && blogPosts.length &&
              <Grid
                style={{ width: "100%", padding: 0 }}
                spacing={0}
                container
              >
                <Grid
                  style={{ width: "100%", padding: 0, height: isMobile ? 'auto' : 70 }}
                  spacing={0}
                  container
                >
                  <Grid sm={4} item >

                  </Grid>
                  <Grid sm={4} xs={12} item >
                    <MainText>News</MainText>
                  </Grid>
                  <Grid sm={4} xs={12} item align="right" style={{ paddingTop: 20 }} >
                    <SectionLineTitle size={!isMobile ? 'big' : 'small'} style={isMobile ? {marginBottom: 35} : {}}>
                      {format(new Date(firstPost.date), "PPP", { awareOfUnicodeTokens: true })}
                    </SectionLineTitle>
                  </Grid>
                </Grid>

                <Grid
                  style={{ minHeight: "100px", width: "100%", padding: 0, paddingLeft: isMobile ? 0 : 100, paddingRight: isMobile ? 0 : 100, marginBottom: 66 }}
                  spacing={0}
                  container
                >
                  <Grid sm={6} xs={12} item style={{ paddingLeft: isMobile ? 0 : 40 }}>
                    <img alt="" src={cdnURL + firstPost.src} style={{ width: '100%', height: 'auto' }} />
                  </Grid>
                  <Grid sm={6} xs={12} item>

                    <Box pl={!isMobile ? 5 : 0} pt={isMobile ? 1 : 0}>
                      <MainNewsTitle>
                        {firstPost.title}
                      </MainNewsTitle>

                      <MainDescription>
                        <div dangerouslySetInnerHTML={{ __html: firstPost.content }} />
                      </MainDescription>

                      <ArrowButtonLink to={firstPost.url} label={'Read More'} style={!isMobile ? {} : { width: '100%', display: 'block', textAlign: 'center', margin: 0, marginTop: 20 }} />
                    </Box>
                  </Grid>
                </Grid>

                <Grid container id="search">

                  {!isMobile && <Grid xs={6} item>
                    <Grid container alignItems={'center'} style={{ marginTop: 26 }}>
                      <ArrowDownIcon /> <SmallGreyText>More News</SmallGreyText>
                    </Grid>
                  </Grid>}

                  {!isMobile && related.length &&
                    <Grid xs={6} item align="right">
                      <Grid
                        container
                        style={{ marginRight: -40, display: 'inline-block', width: 'auto' }}
                        direction="column"
                        justify="center"
                        alignItems="stretch"
                      >
                        <Grid item xs={12} align="left">
                          <SmallerGreyText>RELATED</SmallerGreyText>
                        </Grid>
                        <Grid item xs={12}>
                          <Grid container direction="row">
                            {related && related.map(relatedPost => <Grid item xs>
                              <Link to={relatedPost.url}>
                                <img title={relatedPost.title} alt="" src={cdnURL + relatedPost.src} style={{ objectFit: 'cover', width: 180, height: 90 }} />
                              </Link>
                            </Grid>)}
                          </Grid>
                        </Grid>
                      </Grid>

                    </Grid>
                  }
                </Grid>
              </Grid>}
          </div>
        </div>

        <div style={{ marginTop: 74 }}>
          <Grid container>
            <Grid item sm xs={12}>
              <MainTextLarge>
                <DynamicElement id="5ffa388b586fa2f4d4147a9a">
                  {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
                </DynamicElement>
              </MainTextLarge>
            </Grid>
            <Grid item sm xs={12}>
              {morePosts.length > 6 &&
                <Counter>{`${selectedImg + 1}`.padStart(2, '0')}</Counter>
              }
              <StyledSearchBar
                placeholder={'Search News...'}
                value={this.state.searchValue}
                onChange={(newValue) => this.setState({ searchValue: newValue })}
                onRequestSearch={() => console.log(this.state.searchValue)}
                onCancelSearch={() => this.setState({ searchValue: '' })}
                postsCount={morePosts.length}
              />
            </Grid>
          </Grid>
          <Box
            display="flex"
            justifyContent="left"
            className={classes.wrapper}
            container
          >
            {!isMobile && selectedImg !== 0 &&
              <Rectangle side={'left'} onClick={() => this.onChange(selectedImg)} />
            }
            <div className={classes.gridListWrapper}>
              {morePosts.length === 0 && searchValue &&
                <p>
                  Your search query using "{searchValue}" has returned no results.
                </p>
              }
              {morePosts.length !== 0 &&
                <GridList className={classes.gridList} cols={isMobile ? 12 : 3}>
                  {this.getVerticalBlogposts(morePosts, isMobile)}
                </GridList>
              }
            </div>
            {!isMobile && (selectedImg !== Math.ceil(morePosts.length / (isMobile ? 3 : 6)) - 1) &&
              <Rectangle side={'right'} onClick={() => this.onChange(selectedImg + (isMobile ? 2 : 2))} />
            }
          </Box>

          {isMobile && <Box
            display="flex"
            justifyContent="left"
            container
            style={{
              marginTop: 40,
              paddingBottom: 80,
              position: 'relative',
              justifyContent: 'space-around',
            }}
          >
            <div style={{ flex: 1, width: '50%', paddingRight: 10 }}>
              {selectedImg !== 0 &&
                <Rectangle side={'left'} onClick={() => this.onChange(selectedImg)} />
              }
            </div>
            <div style={{ flex: 1, width: '50%', paddingLeft: 10 }}>
              {(selectedImg !== Math.ceil(morePosts.length / (isMobile ? 3 : 6)) - 1) &&
                <Rectangle side={'right'} onClick={() => this.onChange(selectedImg + (isMobile ? 2 : 2))} />
              }
            </div>
          </Box>}

          {morePosts.length > 6 && <div>
            <SlideText>
              Click and slide to browse articles
            </SlideText>
            <Grid container alignItems="center">
              <Grid item sm={4} xs={12}>
                <Grid className={classes.sliderWrapper} container spacing={1} alignItems="center">
                  <Grid item>
                    <SliderLabel side="left">{`${selectedImg + 1}`.padStart(2, '0')}</SliderLabel>
                  </Grid>
                  <Grid item xs>
                    <HenigSlider
                      defaultValue={1}
                      getAriaValueText={this.valuetext}
                      aria-labelledby="discrete-slider"
                      valueLabelDisplay="auto"
                      step={1}
                      min={1}
                      max={Math.ceil(morePosts.length / 6)}
                      value={selectedImg + 1}
                      onChange={(e, v) => this.onChange(v)}
                    />
                  </Grid>
                  <Grid item>
                    <SliderLabel side="right">
                      {`${Math.ceil(morePosts.length / 6)}`.padStart(2, '0')}
                    </SliderLabel>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={4} align="center">
                {/* <ArrowButtonLink to={'/special-offers'} label={'View All'} /> */}
              </Grid>
            </Grid>
          </div>}
        </div>
      </div>
    );
  }
}

Blog.propTypes = {
  selectBlog: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  width: PropTypes.string.isRequired,
};

export default withWidth()(withStyles(styles, { withTheme: true })(Blog));
